export class BaseUnitTimes {
  unitUnitIsn: number;
  companyPartNumber: string;
  companySerialNumber: string;
  manufacturersPartNumber: string;
  manufacturersSerialNumber: string;
  location: string;
  department: string;
  position: string;
  status: string;
  timeSinceInstall: number;
  cyclesSinceInstall: number;
  timeSinceOverhaul: number;
  cyclesSinceOverhaul: number;
  timeSinceNew: number;
  cyclesSinceNew: number;
  timeSinceRepair: number;
  cyclesSinceRepair: number;
}
